import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components/macro';
import ToolboxTutorial from '../../../../assets/tutorial/toolboxTutorial';
import { Caption, Text } from '../../theme/components';
import ExampleCaseItem from '../components/ExampleCaseItem';
import PageWrapper from '../components/PageWrapper';
import TutorialHeader from '../components/TutorialHeader';

const ExampleWrapper = styled.div`
  width: 100%;
  margin-top: 15%;
`;
const StyledCaption = styled(Caption)`
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 1em;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.textColors.secondary};
  margin-top: 15%;
`;
const IconWrapper = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  margin: 0.5em;
  background: #ffd13f;
  opacity: 0.7;
  align-items: center;
  justify-content: center;
  border-radius: 10px;

  svg {
    width: 70%;
    height: 70%;
  }
`;

const Step7 = ({ nextSlide }) => (
  <PageWrapper onButtonClick={nextSlide}>
    <TutorialHeader>
      Kategorię i zasięg sprawy poznasz, patrząc na{' '}
      <b>ikonę z lewej strony sprawy</b>
    </TutorialHeader>
    <ExampleWrapper>
      <StyledCaption>Przykład</StyledCaption>
      <ExampleCaseItem />
    </ExampleWrapper>
    <TextWrapper>
      <IconWrapper>
        <ToolboxTutorial />
      </IconWrapper>
      <Text>
        Kategoria:
        <br />
        <b>Awarie</b>
      </Text>
    </TextWrapper>
  </PageWrapper>
);

Step7.propTypes = {
  nextSlide: PropTypes.func.isRequired
};

export default Step7;
